/* Free-gift auto-add for the cart ladder (P2.1 and P2.2, 19 Oct 2026, decision 127).
   The add half of the pair: assets/up-cart-drawer.js removes a gift whose step is no longer met and collapses
   duplicate gift lines; this file adds a gift once the qualifying total reaches its step. The qualifying total is
   window.UpkCart.qualifying (assets/upk-cart-events.js), the mirror of snippets/upk-ladder-qualifying (P6b.1): every
   paid line counts, letters and charms included; not the gift lines, the handles and product ids Liquid lists in
   #UpCartConfig (the gift box, the gift products, the Theme settings list) or a line priced at 0.
   Gifts come from #UpCartConfig, resolved by handle in Liquid (snippets/upk-ladder-steps): ids are never typed here.
   A gift step whose product did not resolve (blank handle, not on the Online Store, sold out) is listed in
   config.giftsSkipped and logged to the console once; nothing is added for it. Nothing runs while the ladder is off.
   Runs after every cart mutation (upk:cart:add and upk:cart:change from the one fetch interceptor), after every
   drawer re-render and when the bag icon is tapped, so a code that moves the total across a step adds the gift too.
   P13a.8: on page load it runs only when #UpCartConfig says the cart has lines and the qualifying total reaches the
   lowest gift step; an empty cart no longer costs a /cart.js fetch on every page view.
   window.UpkGiftAutoAdd.run() returns a promise, so the checkout guard in up-cart-drawer.js can wait for it. */
(function () {
  'use strict';
  if (window.UpkGiftAutoAdd) return;
  var busy = null;
  var timer;
  var loggedSkips = '';

  function cfg() {
    if (window.UpkCart) return window.UpkCart.getConfig();
    try { return JSON.parse(document.getElementById('UpCartConfig').textContent) || {}; } catch (e) { return {}; }
  }
  function isGift(i) { return !!(i.properties && (i.properties._gift === 'true' || i.properties._gift === true)); }
  function qualifying(cart, c) {
    if (window.UpkCart) return window.UpkCart.qualifying(cart, c);
    var before = !c || c.countBeforeDiscount !== false;
    return cart.items.reduce(function (s, i) { return (isGift(i) || !(i.original_line_price > 0)) ? s : s + (before ? i.original_line_price : i.final_line_price); }, 0);
  }
  function logSkipped(c) {
    var list = c.giftsSkipped || [];
    var key = JSON.stringify(list);
    if (!list.length || key === loggedSkips) return;
    loggedSkips = key;
    list.forEach(function (s) {
      try { console.warn('[upk ladder] step ' + s.step + ' skipped: ' + (s.handle || '(no handle)') + ', ' + s.reason); } catch (e) { /* noop */ }
    });
  }

  function run() {
    if (busy) return busy;
    var c = cfg();
    logSkipped(c);
    if (!c.ladderLive) return Promise.resolve(null);
    var gifts = (c.gifts || []).filter(function (g) { return g.variantId && g.productId; });
    if (!gifts.length) return Promise.resolve(null);
    busy = fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* P13b (Priyal's decision 2, 20 Oct 2026): a ladder-blocking code on the cart (VAULT70, #UpCartConfig.blockCodes) adds nothing;
           up-cart-drawer.js removes what is there. */
        if (window.UpkCart && window.UpkCart.blocked ? window.UpkCart.blocked(cart, c) : (cart.discount_codes || []).some(function (d) { return d && d.code && d.applicable !== false && (c.blockCodes || ['VAULT70']).map(function (x) { return String(x).toUpperCase(); }).indexOf(String(d.code).toUpperCase()) !== -1; })) return null;
        var total = qualifying(cart, c);
        var have = {};
        cart.items.forEach(function (i) { if (isGift(i)) have[String(i.product_id)] = true; });
        var add = gifts
          .filter(function (g) { return total >= g.thresholdPaise && !have[String(g.productId)]; })
          .map(function (g) { return { id: Number(g.variantId), quantity: 1, properties: { _gift: 'true' } }; });
        if (!add.length) return null;
        return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: add, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
        }).then(function (r) { return r.json(); }).then(function (state) {
          if (state && state.status) {
            /* 422 from Shopify (for example the gift went out of stock between the render and the add): leave it, log it. */
            try { console.warn('[upk ladder] gift add refused: ' + (state.description || state.message || state.status)); } catch (e) { /* noop */ }
            return null;
          }
          var d = document.querySelector('cart-drawer');
          if (d && state && state.sections && typeof d.renderContents === 'function') d.renderContents(state);
          if (document.querySelector('cart-items') && !window.__upkGiftReloaded) {
            /* Cart page: its rows and totals are server-rendered, so show the added gift. */
            window.__upkGiftReloaded = true;
            setTimeout(function () { window.location.reload(); }, 150);
          }
          return state;
        });
      })
      .catch(function () { return null; })
      .then(function (r) { busy = null; return r; });
    return busy;
  }
  function later() { clearTimeout(timer); timer = setTimeout(run, 700); }
  function init() {
    /* P13a.8 (build verification R8): no /cart.js on a plain page view when the drawer's config says the cart is empty, or
       when the qualifying total it printed is below the lowest gift step (nothing could be due). The event-driven runs
       below are unchanged, so a cart that crosses a step still gets its gift. */
    var c0 = cfg();
    var lowest = (c0.gifts || []).reduce(function (m, g) { return (g.thresholdPaise && g.thresholdPaise < m) ? g.thresholdPaise : m; }, Infinity);
    var idle = (c0.itemCount === 0) || (typeof c0.qualifyingPaise === 'number' && c0.qualifyingPaise < lowest);
    if (idle) logSkipped(c0); else run();
    document.addEventListener('upk:cart:add', later);
    document.addEventListener('upk:cart:change', later);
    var d = document.querySelector('cart-drawer');
    if (d && window.MutationObserver) new MutationObserver(later).observe(d, { childList: true, subtree: true });
    var b = document.getElementById('cart-icon-bubble');
    if (b) b.addEventListener('click', later);
  }
  window.UpkGiftAutoAdd = { run: run };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
